<template>
  <div class="w-full">
    <VeeForm v-slot="{ errors }" as="">
      <NText>
        {{ t('modules.watchlist.name') }}
      </NText>

      <VeeField
        v-slot="{ field }"
        v-model="title"
        name="title"
        :rules="{
          required: true,
          maxLength: [25],
        }"
      >
        <NInput
          v-focus
          :model-value="title"
          :placeholder="t('modules.watchlist.create_watchlist_placeholder')"
          required
          v-bind="field"
          :error="errors.title"
          show-error
          class="w-full mt-1"
        />
      </VeeField>

      <NButton
        class="w-full mt-6"
        :disabled="isCreatingWatchlist"
        @click="addNewWatchlist"
      >
        {{ t('modules.watchlist.create') }}
      </NButton>
    </VeeForm>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast, useDialog } from '@negar/core';
import { useCreateWatchlist } from '@core/watchlist';
import { Watchlist } from '@libs/api-reference';

import vFocus from '@/directives/focus';

type CreateWatchlistDialogEmitsType = {
  (e: 'afterCreate', watchlist: Watchlist): void;
};

const emit = defineEmits<CreateWatchlistDialogEmitsType>();

const title = ref('');

const { t } = useI18n();
const { remove } = useDialog();
const toast = useToast();

const { addNewWatchlist, isCreatingWatchlist } = useCreateWatchlist(title, {
  onSuccess: (response) => {
    const newWatchlistData: Watchlist = response.data.result;

    emit('afterCreate', newWatchlistData);

    toast.neutral({
      message: t('modules.watchlist.create_watchlist_message', {
        watchlistName: title.value,
      }),
      duration: 3000,
    });

    remove();
  },
  onReject: () => {
    toast.negative({
      message: t('modules.watchlist.create_watchlist_failed_message', {
        watchlistName: title.value,
      }),
      duration: 3000,
    });
  },
});
</script>
